import { parseEmployeeCsv, type EmployeeCsvRow } from "./csv";
import { normalizeKoreanMobile } from "./phone";

const EMPLOYEE_HEADERS = ["이름", "이메일", "휴대폰번호", "소속", "기본식사장소"];

function cellText(value: unknown): string {
  return value === null || value === undefined ? "" : String(value).trim();
}

export function parseEmployeeSheetRows(rows: unknown[][]): EmployeeCsvRow[] {
  const [headers, ...dataRows] = rows;
  if (
    !headers ||
    EMPLOYEE_HEADERS.some((header, index) => cellText(headers[index]).replaceAll(" ", "") !== header)
  ) {
    throw new Error("닥터스 엑셀 양식의 열 이름을 그대로 사용해 주세요.");
  }

  const parsed = dataRows
    .map((values) => {
      const rawPhone = cellText(values[2]);
      return {
        name: cellText(values[0]),
        email: cellText(values[1]).toLowerCase(),
        phone: normalizeKoreanMobile(rawPhone) ?? rawPhone,
        organization: cellText(values[3]),
        defaultLocation: cellText(values[4]),
      };
    })
    .filter((row) => Object.values(row).some(Boolean));

  if (!parsed.length) throw new Error("등록할 직원이 없습니다.");
  return parsed;
}

export async function parseEmployeeImportFile(file: File): Promise<EmployeeCsvRow[]> {
  if (file.name.toLowerCase().endsWith(".csv")) return parseEmployeeCsv(await file.text());
  if (!file.name.toLowerCase().endsWith(".xlsx")) {
    throw new Error("엑셀(.xlsx) 또는 CSV(.csv) 파일을 선택해 주세요.");
  }
  const { readSheet } = await import("read-excel-file/universal");
  return parseEmployeeSheetRows(await readSheet(file));
}
